import { useContext, useEffect, useState } from "react";
import Listingnavbar from "../components/listingnavbar";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import EditUserModal from "../modals/editUserModal";
import AddUserModal from "../modals/addUserModal";
import {
  ApproveUserAPI,
  GetApprovedUsersAPI,
  GetPendingUsersAPI,
} from "../APIs/API";
import { MyContext } from "../MyContext/MyProvider";
import UserTable from "./UserTable";

const UseradminListing = () => {
  const { setCurrentUserToEdit, setIsLoading } = useContext(MyContext);

  const navigate = useNavigate();
  const [pendingUsers, setPendingUsers] = useState([]);
  const [approvedUsers, setApprovedUsers] = useState([]);
  const [currentList, setCurrentList] = useState("Pending");
  const [isedituserModalOpen, setisedituserModalOpen] = useState(false);
  const [isadduserModalOpen, setisadduserModalOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const showeditModal = () => {
    setisedituserModalOpen(true);
  };
  const showaddModal = () => {
    setisadduserModalOpen(true);
  };

  const handleApprovalChange = (email) => {
    let updatedUser = null;
    setPendingUsers((prevUsers) =>
      prevUsers.map((user) => {
        if (user.email === email) {
          const newStatus = user.status === "approved" ? "pending" : "approve";

          updatedUser = {
            email: user.email,
            action: newStatus,
          };
          return {
            ...user,
            status: newStatus,
          };
        }
        return user;
      })
    );

    setApprovedUsers((prevUsers) =>
      prevUsers.map((user) => {
        if (user.email === email) {
          const newStatus = user.status === "approved" ? "pending" : "approve";
          updatedUser = {
            email: user.email,
            action: newStatus,
          };
          return {
            ...user,
            status: newStatus,
          };
        }
        return user;
      })
    );

    setTimeout(() => {
      if (updatedUser) {
        updateUserStatus(updatedUser);
      }
    }, 0);
  };

  const updateUserStatus = async (updatedUser) => {
    try {
      const res = await ApproveUserAPI(updatedUser);
      setRefresh((prev) => !prev);
    } catch (error) {
      console.log(error);
    }
  };

  const toggleList = () => {
    setCurrentList(currentList === "Approved" ? "Pending" : "Approved");
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setIsLoading(true);

        const [pendingRes, approvedRes] = await Promise.all([
          GetPendingUsersAPI(),
          GetApprovedUsersAPI(),
        ]);

        setPendingUsers(pendingRes.pending_users);
        setApprovedUsers(approvedRes.approved_users);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUsers();
  }, [refresh]);

  return (
    <>
      <Listingnavbar />
      <div className="client-listing-main">
      <div
            className="back-btn v-center h-center gap-2 cursor-pointer"
            onClick={() => {
              navigate("/settings");
            }}
          >
            <Icon
              icon="ion:chevron-back-outline"
              width={20}
              height={18}
              color="#FFFFFF"
            />
            <label className="large fw-medium text-white roboto-family ">
              Back
            </label>
          </div>
        <h2 className="text-medium-black roboto-family text-center">
          {/* USER/ADMIN LISTING */}
          {currentList} Users
        </h2>
        <div className="d-flex v-center h-center mt-4">
          <button className="modal-trans-btn switch-btn" onClick={toggleList}>
            Switch to {currentList === "Approved" ? "Pending " : "Approved "}
            users
          </button>
        </div>
        <div className="listing-top-container d-flex space-between">
          

          {/* <div
            className="add-btn v-center h-center cursor-pointer"
            onClick={showaddModal}
          >
            <Icon
              icon="zondicons:add-outline"
              width={30}
              height={23}
              color="#FFFFFF"
            />
          </div> */}
        </div>
        <div className="listingclient-table mt-4">
          {/* <table className="m-auto">
            <thead>
              <tr className="send-email-thead ">
                <th>
                  <div className=" px-3">Name</div>
                </th>
                <th>Email</th>
                <th>Status</th>
                <th>Edit</th>

              </tr>
            </thead>
            <tbody>
              {currentList === "Approved"
                ? approvedUsers?.map((user, index) => (
                    <tr key={index} className="send-email-tbody ">
                      <td className="first-td">
                        <div className="px-3">{`${user.firstname} ${user.lastname}`}</div>
                      </td>
                      <td>{user.email}</td>
                      <td>
                        <label className="switch">
                          <input
                            onChange={() => handleApprovalChange(user.email)}
                            type="checkbox"
                            checked={user.status !== "pending"}
                          />
                          <span className="slider round"></span>
                        </label>
                      </td>

                      <td>
                        <img
                          src="../../assets/icons/user-edit.svg"
                          alt="edit"
                          className=" cursor-pointer user-icon"
                          onClick={() => {
                            showeditModal();
                            setCurrentUserToEdit(user.email);
                          }}
                        />
                      </td>
                    </tr>
                  ))
                : pendingUsers?.map((user, index) => (
                    <tr key={index} className="send-email-tbody ">
                      <td className="first-td">
                        <div className="px-3">{`${user.firstname} ${user.lastname}`}</div>
                      </td>
                      <td>{user.email}</td>
                      <td>
                        <label className="switch">
                          <input
                            onChange={() => handleApprovalChange(user.email)}
                            type="checkbox"
                            checked={user.status === "approve"}
                          />
                          <span className="slider round"></span>
                        </label>
                      </td>

                      <td>
                        <img
                          src="../../assets/icons/user-edit.svg"
                          alt="edit"
                          className=" cursor-pointer user-icon"
                          onClick={() => {
                            showeditModal();
                            setCurrentUserToEdit(user.email);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
            </tbody>
          </table> */}
          <UserTable
            key={currentList}
            list={currentList === "Pending" ? pendingUsers : approvedUsers}
            handleApprovalChange={handleApprovalChange}
            setCurrentUserToEdit={setCurrentUserToEdit}
            showeditModal={showeditModal}
          />
        </div>
      </div>
      <EditUserModal
        isEditUserModalOpen={isedituserModalOpen}
        setisEditUserModalOpen={setisedituserModalOpen}
      />
      <AddUserModal
        isadduserModalOpen={isadduserModalOpen}
        setisadduserModalOpen={setisadduserModalOpen}
      />
    </>
  );
};

export default UseradminListing;
